import { Component, type ComponentChildren } from 'preact';

import { Button } from '@amumin/ui';

import { EmptyState } from '../lib/EmptyState.js';
import { appText } from '../state/session.js';

interface State {
  error: unknown;
}

/**
 * Onverwachte fout in een scherm (DESIGN.md §8.X): "Oeps, dat ging mis" met één knop om opnieuw
 * te laden, in plaats van een wit scherm. De fout gaat naar de console voor ontwikkelaars.
 */
export class CrashBoundary extends Component<{ children: ComponentChildren }, State> {
  override state: State = { error: null };

  override componentDidCatch(error: unknown): void {
    console.error(error);
    this.setState({ error });
  }

  override render() {
    if (!this.state.error) return this.props.children;
    const a = appText.value;
    return (
      <main class="auth-page not-found" data-name="crash">
        <EmptyState
          title={a.crashTitle}
          body={a.crashBody}
          action={
            <Button
              name="reload"
              variant="primary"
              icon="refresh-cw"
              onPress={() => window.location.reload()}
            >
              {a.reload}
            </Button>
          }
        />
      </main>
    );
  }
}
